import { Link, Navigate } from "react-router-dom";
import { PageHeader } from "@/components/common/PageHeader";
import { Button } from "@/components/ui/button";
import { Mic, Smartphone, Sparkles } from "lucide-react";
import { BrainNav } from "@/components/brain/BrainNav";
import { BRAIN_EXTENDED_FEATURES_ENABLED } from "@/lib/featureFlags";
import { useAssistantName } from "@/hooks/useAssistantName";

export default function VoiceMemosPage() {
  const assistantName = useAssistantName();
  if (!BRAIN_EXTENDED_FEATURES_ENABLED) return <Navigate to="/brain" replace />;
  return (
    <div className="flex flex-col h-full min-w-0 overflow-y-auto overflow-x-hidden scrollbar-thin">
      <PageHeader
        title="Voice memos"
        description={`Record from the Sellyx mobile app. ${assistantName} transcribes and remembers everything.`}
      />
      <BrainNav />

      <div className="p-4 sm:p-6 max-w-5xl space-y-5 min-w-0">
        <div className="rounded-2xl border-2 border-indigo-200 bg-gradient-to-br from-indigo-50/70 via-white to-violet-50/40 p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4" data-testid="phase8-banner">
          <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-indigo-500 to-violet-500 text-white flex items-center justify-center shrink-0">
            <Smartphone size={22} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="inline-flex items-center gap-1.5 rounded-full bg-white ring-1 ring-indigo-200 px-2 py-0.5 text-[10px] uppercase tracking-wider text-indigo-700 font-semibold mb-1">
              <Sparkles size={10} /> Phase 8 · Mobile companion
            </div>
            <div className="text-[14px] font-semibold text-slate-900">Sellyx mobile comes in Phase 8.</div>
            <div className="text-[12px] text-slate-600 mt-0.5">
              Record voice memos · pair WhatsApp by QR · monitor {assistantName} on the go.
            </div>
          </div>
        </div>

        <div className="rounded-xl border border-slate-200 bg-white p-6 sm:p-10 text-center" data-testid="voice-memos-empty">
          <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-indigo-50 text-indigo-600 mb-4">
            <Mic size={22} />
          </div>
          <h3 className="text-[18px] font-semibold text-slate-900">No voice memos yet</h3>
          <p className="mt-2 text-[13px] text-slate-600 max-w-sm mx-auto">
            Voice memo recording and transcription will be available with the mobile app. Nothing is indexed until you record your first memo.
          </p>
          <Button asChild variant="outline" size="sm" className="mt-4 h-10 sm:h-8 w-full sm:w-auto">
            <Link to="/brain">Back to Brain</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
